import { defineTokens } from '@chakra-ui/react';

export const shadows = defineTokens.shadows({
  outline: { value: '0 0 0 3px rgb(70,71,218, 0.6)' },
});
